import clsx from 'clsx';
import type { ReactNode } from 'react';
import { BAND_CLASS, BAND_LABEL } from '@/lib/format';
import type { ResultBand } from '@/lib/types';

export function Badge({
  children,
  className,
  title,
}: {
  children: ReactNode;
  className?: string;
  title?: string;
}) {
  return (
    <span
      title={title}
      className={clsx(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1',
        'text-xs font-semibold',
        className ?? 'border-line bg-surface-raised text-muted',
      )}
    >
      {children}
    </span>
  );
}

/** R4 — the three-band result label. Copy and colour both come from one place. */
export function BandBadge({ band, className }: { band: ResultBand | null; className?: string }) {
  if (!band) {
    return (
      <Badge className={clsx('border-line bg-surface-raised text-muted', className)}>
        Not scored
      </Badge>
    );
  }
  return (
    <Badge className={clsx(BAND_CLASS[band], className)}>{BAND_LABEL[band]}</Badge>
  );
}

/**
 * R3 — marks an attempt that is too thin to plot. Carries its own explanation,
 * because "partial day" is meaningless without it.
 */
export function PartialDayBadge() {
  return (
    <Badge
      className="border-secondary/35 bg-secondary-soft text-secondary"
      title="Most questions didn't apply that day, so it isn't included in your trend or averages."
    >
      Partial day
    </Badge>
  );
}
